import { IPCodeWarnFlags } from '@common/interfaces';
import { getPriceValidation, getSelectedPcodes, masterAPIToSavedDataValidation } from '@utils';
import { IOrder, IPcodes } from 'next-common';
import { useEffect, useState } from 'react';
import { IPcodeMaster, IVehicleStockEcomItem } from 'sales-types-common';

export const useImporterOptions = (
  order: IOrder,
  vehiclePCodes: IPcodeMaster[],
  selectedVehicleData: IVehicleStockEcomItem
) => {
  const [selectedOptions, setSelectedOptions] = useState<IPcodes[]>([]);
  const [preSelectedOptions, setPreSelectedOptions] = useState<IPcodes[]>([]);
  const [savedOptions, setSavedOptions] = useState<IPcodes[]>([]);

  const [warning, setWarning] = useState<IPCodeWarnFlags>({
    showDateWarn: false,
    showVehicleStatusMismatchWarn: false,
    showMasterAPIMismatchWarn: false,
    isPriceMismatch: false,
    showTTCodeWarn: false,
  });

  useEffect(() => {
    if (order && vehiclePCodes) {
      const mismatchedData = masterAPIToSavedDataValidation(order, vehiclePCodes);
      const priceMismatchedData = !order?.isEditOrder ? getPriceValidation(order, mismatchedData, vehiclePCodes) : [];

      setWarning((prev) => ({
        ...prev,
        showMasterAPIMismatchWarn: Boolean(mismatchedData?.length),
        isPriceMismatch: Boolean(priceMismatchedData?.length),
      }));

      const { pCodes, preSelectedPcodes } = getSelectedPcodes(
        order?.pCodes,
        selectedVehicleData,
        vehiclePCodes,
        !order?.isEditOrder
      );

      setPreSelectedOptions([...(order?.pCodes || []), ...preSelectedPcodes]);
      setSelectedOptions(pCodes ?? []);
    }
  }, [order?.id, vehiclePCodes, selectedVehicleData]);

  useEffect(() => {
    setSavedOptions(order?.pCodes || []);
  }, [order?.pCodes]);

  return {
    selectedOptions,
    setSelectedOptions,
    preSelectedOptions,
    savedOptions,
    warning,
    setWarning,
  };
};
